import { IAppState } from '../../redux';

export function selectPrevBet(state: IAppState): number {
  const {
    auction: { prevBet },
  } = state;

  return prevBet;
}
